import React from "react";
import useCountdown from "../../hooks/useCountdown";

type Props = {
    time: number;
    ttl?: number;
    onTimeUp: () => void;
};

const Countdown = ({ time, ttl, onTimeUp }: Props) => {
    const timeRemaining = useCountdown(time, onTimeUp, ttl);

    return <React.Fragment>{timeRemaining}</React.Fragment>;
};

export default Countdown;
